import {
  HEADER_MOBILE_MAX_HEIGHT,
  HEADER_MOBILE_PADDING,
  HEADER_PADDING_TOP,
  MAIN_LAYOUT_MOBILE_PADDING,
} from '@foxtaibox/foxtailbox-frontend-core';
import { Stack, styled } from '@mui/material';

const MenuStack = styled(Stack)(({ theme }) => ({
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    position: 'relative',
    zIndex: 9,
    left: '-70px',
    minWidth: 'calc(100% + 140px)',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '16px 70px',
    maxHeight: `calc(100vh - ${HEADER_MOBILE_MAX_HEIGHT - HEADER_PADDING_TOP}px)`,
    height: '100vh',
    borderRadius: '12px',
    transition: 'all ease 500ms',
  },
  [theme.breakpoints.down('sm')]: {
    left: '-16px',
    minWidth: 'calc(100% + 32px)',
    maxHeight: `calc(100vh - ${HEADER_MOBILE_MAX_HEIGHT - HEADER_PADDING_TOP + HEADER_MOBILE_PADDING + MAIN_LAYOUT_MOBILE_PADDING}px)`,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));

export default MenuStack;
